var exports = {
  "kL": "x7f9a0e16--fe498f--container",
  "hF": "x7f9a0e16--fe498f--input",
  "EK": "x7f9a0e16--fe498f--suggests",
  "ZA": "x7f9a0e16--fe498f--suggest",
  "iU": "x7f9a0e16--fe498f--message",
};

module.exports = exports;
